import { useCallback } from "react"
import { useSelector } from "react-redux"
import * as uuid from "uuid"
import { getHttpHeaders, getSelectedAccountId } from "../../../auth/selectors"
import { createEventRequest, sendEvent } from "../../../../events/utils"
import { EventType } from "../../../../events/types"
import { FeatureTrackedPayload } from "./types"

export const sendFeatureTracked = async (
    headers: Record<string, any>,
    accountId: string,
    payload: FeatureTrackedPayload
): Promise<void> => {
    await sendEvent(
        headers,
        createEventRequest(
            EventType.FeatureTracked,
            {
                accountId: accountId,
                correlationId: uuid.v4(),
            },
            payload
        )
    )
}

export const useAnalyticsHooks = () => {
    const headers = useSelector(getHttpHeaders)
    const accountId = useSelector(getSelectedAccountId)

    const trackFeature = useCallback(
        async (payload: FeatureTrackedPayload): Promise<boolean> => {
            await sendFeatureTracked(headers, accountId as string, payload)

            return true
        },
        [headers, accountId]
    )

    return {
        trackFeature: trackFeature,
    }
}
